import api from './index';

const url = 'pos';

export default {
	async validateTableSession(token, data) {
		return api.post(`${url}/table-session/${token}/validate`, data);
	},
};
